// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"50":"6b5a709e","455":"39ddd0ed","644":"f8976b7c"}[chunkId] + ".chunk.js";
};